// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1DEB-","content":"RecentSearches_content__3VGHd"};